<template>
    <div class="main-container">
        <el-form :inline="true" :model="searchForm" size="small" ref="searchForm" @keyup.enter.native="handleSearch"
            label-width="70px">
            <el-form-item label="酒店名称" prop="hotelName">
                <el-input v-model="searchForm.hotelName" placeholder="请输入酒店名称" style="width: 210px"></el-input>
            </el-form-item>
            <el-form-item label="分成用户" prop="username">
                <el-input v-model="searchForm.username" placeholder="请输入分成用户" style="width: 210px"></el-input>
            </el-form-item>
            <el-form-item label="订单号" prop="orderNo">
                <el-input v-model="searchForm.orderNo" placeholder="请输入订单号" style="width: 210px"></el-input>
            </el-form-item>
            <el-form-item label="时间" prop="selectTime">
                <el-date-picker v-model="selectTime" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                    key="picker1" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"  style="width: 230px"
                    @change="handleChangeDate"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleSearch" size="small">搜索</el-button>
                <el-button @click="handleReset" size="small">重置</el-button>
            </el-form-item>
        </el-form>

        <el-table border size="small" style="width:100%;margin-top:10px;" :data="tableData" v-loading="isLoading"
            element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)">
            <el-table-column type="index" label="#" align="center" fixed="left"></el-table-column>
            <el-table-column prop="createTime" label="时间"></el-table-column>
            <el-table-column prop="hotelName" label="酒店名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="orderNo" label="订单号"></el-table-column>
            <el-table-column prop="orderPayment" label="支付总金额"></el-table-column>
            <el-table-column prop="money" label="分成金额"></el-table-column>
            <el-table-column prop="username" label="分成用户"></el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
        </el-table>
        <el-pagination @size-change="handleChangeSize" @current-change="handleChangePage"
            style="text-align:right;margin-top:10px;" :current-page="searchForm.pageNumber" :page-sizes="[10, 20, 50]"
            :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>

<script>
export default {
    data() {
        return {
            searchForm: {
                hotelName: '',
                username: '',
                orderNo: '',
                startDate: '',
                endDate: '',
                pageSize: 10,
                pageNumber: 1,
            },
            total: 0,
            tableData: [],
            isLoading: false,
            submitLoading: false,
            selectTime: null
        }
    },
    created() {
        this.getTableData();
    },
    methods: {
        handleChangeDate(date) {
            if (date.length) {
                this.searchForm.startDate = date[0];
                this.searchForm.endDate = date[1];
            }
        },
        handleSearch() {
            this.searchForm.pageNumber = 1;
            this.getTableData();
        },

        handleReset() {
            this.searchForm = {
                hotelName: '',
                username: '',
                orderNo: '',
                startDate: '',
                endDate: '',
                pageSize: 10,
                pageNumber: 1,
            };
            this.getTableData();
        },

        handleChangePage(page) {
            this.searchForm.pageNumber = page;
            this.getTableData();
        },

        handleChangeSize(size) {
            this.searchForm.pageNumber = 1;
            this.searchForm.pageSize = size;
            this.getTableData();
        },
        getTableData() {
            this.isLoading = true;
            this.getRequest("/df-profit/finance/getPageList", this.searchForm)
                .then(res => {
                    this.isLoading = false;
                    let data = res.data;
                    if (data.code == 200) {
                        this.tableData = data.data.records;
                        this.total = data.data.total;
                    }
                }).catch(() => {
                    this.isLoading = false;
                })
        }

    },
}
</script>
<style type="less">
@import url("./index.less");
</style>


